<template>
	<div class="page-content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="
              page-title-box
              d-sm-flex
              align-items-center
              justify-content-between
            ">
						<h4 class="mb-sm-0">Tutup Akun</h4>

						<div class="page-title-right">
							<ol class="breadcrumb m-0">
								<li class="breadcrumb-item active">Form Tutup Akun</li>
							</ol>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-header align-items-center d-flex">
							<h4 class="card-title mb-0 flex-grow-1">
								Form Tutup Akun
							</h4>
						</div>

						<div class="card-body">
							<!-- Loading State -->
							<div v-if="loading" class="text-center py-5">
								<div class="spinner-border text-primary" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</div>

							<!-- Already Submitted (Status bukan pending) -->
							<div v-else-if="alreadySubmitted && !showEditForm" class="text-center py-5">
								<div class="mb-4">
									<i class="bx bx-check-circle display-3 text-success"></i>
								</div>
								<h5 class="mb-3">Form Tutup Akun Sudah Terkirim</h5>
								<p class="text-muted mb-4">
									Anda sudah mengisi form tutup akun.<br>
									Status: <span class="badge" :class="{
										'bg-warning': closeAccountData?.status === 'pending',
										'bg-info': closeAccountData?.status === 'process',
										'bg-success': closeAccountData?.status === 'success'
									}">{{ closeAccountData?.status?.toUpperCase() }}</span><br>
									Proses pencairan akan memakan waktu kurang lebih 3 bulan.
								</p>
								
								<!-- Tombol Edit jika status pending -->
								<div v-if="canEdit" class="mb-4">
									<button type="button" class="btn btn-warning" @click="showEditForm = true">
										<i class="bx bx-edit me-2"></i>
										Edit Form Tutup Akun
									</button>
								</div>

								<div class="alert alert-info mx-auto" style="max-width: 600px;" role="alert">
									<i class="bx bx-info-circle me-2"></i>
									<span v-if="canEdit">
										Anda masih dapat mengubah data form karena status masih <strong>PENDING</strong>.
									</span>
									<span v-else>
										Silakan hubungi admin jika ada pertanyaan terkait proses tutup akun Anda.
									</span>
								</div>
							</div>

							<!-- Show Close Account Form (Create or Edit) -->
							<div v-else>
								<div v-if="canEdit && showEditForm" class="alert alert-warning mb-4" role="alert">
									<i class="bx bx-info-circle me-2"></i>
									<strong>Mode Edit:</strong> Form tutup akun Anda masih berstatus <strong>PENDING</strong>. 
									Anda dapat mengubah data di bawah ini.
								</div>
								<CloseAccountForm 
									:closeAccountData="closeAccountData"
									:isEdit="canEdit && showEditForm"
									@submit="handleFormSubmit" 
									:submitting="submitting" 
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { endpoint } from "../../host";
import httpService from "../../services/http-service";
import errorService from '../../services/error-service';
import Swal from 'sweetalert2';
import CloseAccountForm from './components/CloseAccountForm.vue';

export default {
	components: {
		CloseAccountForm,
	},

	mounted() {
		this.checkExistingSubmission();
	},

	data() {
		return {
			loading: true,
			submitting: false,
			alreadySubmitted: false,
			closeAccountData: null,
			canEdit: false,
			showEditForm: false,
		};
	},

	methods: {
		async checkExistingSubmission() {
			try {
				this.loading = true;
				// Try to get form data, if error 400 means already submitted
				await httpService.get(endpoint['close.account.form-data']);
				this.alreadySubmitted = false;
				this.canEdit = false;
			} catch (error) {
				if (error.response && error.response.status === 400) {
					// Already submitted, check if still pending
					await this.checkCloseAccountStatus();
				} else {
					errorService.displayError(error.response);
				}
			} finally {
				this.loading = false;
			}
		},

		async checkCloseAccountStatus() {
			try {
				// Get user's close account data
				const res = await httpService.get(endpoint['close.account.my-close-account']);

				if (res.data.data) {
					const closeAccount = res.data.data;
					this.closeAccountData = closeAccount;
					
					if (closeAccount.status === 'pending') {
						this.canEdit = true;
						this.alreadySubmitted = true; // Show submitted message
						this.showEditForm = false; // Don't show form yet, wait for button click
					} else {
						this.alreadySubmitted = true;
						this.canEdit = false;
						this.showEditForm = false;
					}
				}
			} catch (error) {
				// If error 404, user hasn't submitted yet (shouldn't happen)
				// If other error, assume already submitted
				this.alreadySubmitted = true;
				this.canEdit = false;
				this.showEditForm = false;
			}
		},

		async handleFormSubmit(formData) {
			try {
				this.submitting = true;
				
				let res;
				if (this.canEdit && this.closeAccountData) {
					// Update existing
					res = await httpService.post(
						endpoint['close.account.update'].replace(':id', this.closeAccountData.id),
						formData
					);
				} else {
					// Create new
					res = await httpService.post(endpoint['close.account.submit-form'], formData);
				}

				Swal.fire({
					icon: 'success',
					title: 'Berhasil',
					text: this.canEdit ? 'Form tutup akun berhasil diupdate' : 'Form tutup akun berhasil dikirim',
					timer: 2000,
				});

				// Refresh status
				this.showEditForm = false;
				await this.checkCloseAccountStatus();
			} catch (error) {
				errorService.displayError(error.response);
			} finally {
				this.submitting = false;
			}
		},
	},
};
</script>

<style scoped>
/* Add custom styles if needed */
</style>
